/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {convertSvgToDataUri} from '@ion/core/src/utils/Encoding';
import {dlsColor} from '@ion/dls/src/theme/theme';

export interface IgnitionOnEventMarker {
  size?: number,
  borderColor?: string,
  fillColor?: string
};

/**
 * Utility function that returns an image from SVG that can be passed
 * to the esri Graphic constructor to make a graphic for ignition on events of the asset
 *
 * ```typescript
 *  import {getIgnitionOnEventMarker} from '@ion/dls/src/maps/markers';
 *
 *  return {
 *    type   : 'picture-marker',
 *    url    : getIgnitionOnEventMarker({size, fillColor}),
 *    width  : size,
 *    height : size,
 *    angle  : 0
 * }
 * ```
 */
export const getIgnitionOnEventMarker = ({
  fillColor = dlsColor('caGreen'),
  borderColor = dlsColor('white'),
  size = 24
}: IgnitionOnEventMarker) => {
  const svg = (`
    <svg width='${size}' height='${size}' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9927 5.37563 18.6244 0.00734817 12 0Z' fill='${borderColor}'/>
      <path fill-rule='evenodd' clip-rule='evenodd' d='M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9938 17.5203 17.5203 21.9938 12 22V22Z' fill='${fillColor}'/>
    </svg>
  `);
  return convertSvgToDataUri(svg.trim());
};

export default getIgnitionOnEventMarker;
